import { DecisionFormDataProps } from '../../hooks/useDecisionMakingSubmission';
import { UpdateListSortPropertyJoinProps } from '../../utility/types';
import { api } from '../configs/axiosConfigs';

export const updateListSortPropertyJoin = async ({ requestBody, listSortId, propertyId }: UpdateListSortPropertyJoinProps) => {
  return await api.put(`list-sorts/${listSortId}/property/${propertyId}`, requestBody);
};

export const updatePropertyDecision = async ({ requestBody, listSortId, propertyId }: { requestBody: DecisionFormDataProps, listSortId: string, propertyId: string }) => {
  return await api.put(`list-sorts/${listSortId}/property/${propertyId}`, requestBody);
};
